import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineRelationToFoodDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineRelationToFood/GetDetail?` + params, null);

export const GetMedicineRelationToFoodList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineRelationToFood/GetList?` + params, null);

export const CreateMedicineRelationToFood = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRelationToFood/Create`, data);

export const UpdateMedicineRelationToFood = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRelationToFood/Update`, data);

export const DeleteMedicineRelationToFood = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRelationToFood/Delete`, data);